function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import utils from './utils';
import Thumbnails from './thumbnails';
var Controller = function () {
    function Controller(player) {
        var _this = this;
        _classCallCheck(this, Controller);
        _defineProperty(this, 'showTip', function () {
            if (_this.player.fullScreen.isFullScreen() && _this.thumbnails && _this.thumbnails.container.style.backgroundImage) {
                var px = _this.player.template.bar.getBoundingClientRect().left;
                var tx = _this.player.template.thumb.getBoundingClientRect().left - px;
                var time = _this.player.video.duration * (tx / _this.player.template.bar.offsetWidth);
                if (tx < 0 || tx > _this.player.template.bar.offsetWidth) {
                    return;
                }
                _this.player.template.barTime.innerText = utils.secondToTime(time);
                _this.player.template.thumb.classList.remove('hidden');
                _this.thumbnails.show();
                _this.thumbnails.move(tx + 6);
            } else {
                _this.template.seekTip.classList.remove('hidden');
                _this.template.seekTip.innerHTML = _this.seekTip;
            }
        });
        _defineProperty(this, 'hideTip', function () {
            if (_this.player.fullScreen.isFullScreen() && _this.thumbnails && _this.thumbnails.container.style.backgroundImage) {
                _this.thumbnails.hide();
                _this.player.template.thumb.classList.add('hidden');
            } else {
                _this.template.seekTip.classList.add('hidden');
                _this.template.seekTip.innerHTML = '';
            }
        });
        this.player = player;
        this.template = player.template;
        this.video = player.video;
        this.volume = player.options.volume;
        this.autoHideTimer = null;
        this.clickTimer = null;
        this.lockTimer = null;
        this.moveTime = null;
        this.moveVolume = null;
        this.seekTip = null;
        this.singleClick = false;
        this.lastClickTime = 0;
        this.hideControlflag = true;
        this.isControl = false;
        this.isBarMove = false;
        this.isLocked = false;
        this.showLock = false;
        this.clickFlag = 0;
        this.controllTimer = null;
        this.showDanmaku = player.options.danmaku.showDanmaku;
        if (player.options.danmaku) {
            this.initDanmakuButton();
        }
        this.initLock();
        this.initVideoWrapEvents();
        this.initPlayedBar();
        this.initPlayButton();
        this.initFullButton();
        this.initThumbnails();
    }
    _createClass(Controller, [
        {
            key: 'initLock',
            value: function initLock() {
                var _this2 = this;
                this.template.rightLock.addEventListener(utils.nameMap.dragStart, function (e) {
                    window.event ? window.event.cancelBubble = true : e.stopPropagation();
                    _this2.isLocked = !_this2.isLocked;
                    if (_this2.isLocked) {
                        _this2.hide();
                        _this2.showLock = true;
                        _this2.player.notice('播放器已锁定');
                        _this2.player.events && _this2.player.events.trigger('lock');
                        _this2.template.gestureWrap.classList.remove('unlocked');
                        _this2.template.gestureWrap.classList.add('locked');
                        _this2.lockTimer = setTimeout(function () {
                            _this2.template.leftLock.classList.add('hide');
                            _this2.template.rightLock.classList.add('hide');
                        }, 3000);
                    } else {
                        _this2.setAutoHide();
                        _this2.player.notice('播放器已解锁');
                        _this2.player.events && _this2.player.events.trigger('unlock');
                        clearTimeout(_this2.lockTimer);
                        _this2.template.gestureWrap.classList.remove('locked');
                        _this2.template.gestureWrap.classList.add('unlocked');
                    }
                });
                this.template.leftLock.addEventListener(utils.nameMap.dragStart, function (e) {
                    window.event ? window.event.cancelBubble = true : e.stopPropagation();
                    _this2.isLocked = false;
                    _this2.setAutoHide();
                    _this2.player.notice('播放器已解锁');
                    _this2.player.events && _this2.player.events.trigger('unlock');
                    clearTimeout(_this2.lockTimer);
                    _this2.template.gestureWrap.classList.remove('locked');
                    _this2.template.gestureWrap.classList.add('unlocked');
                });
            }
        },
        {
            key: 'initPlayButton',
            value: function initPlayButton() {
                var _this3 = this;
                this.template.controllerWrap.addEventListener(utils.nameMap.dragStart, function () {
                    window.event ? window.event.cancelBubble = true : e.stopPropagation();
                });
                this.template.headBar.addEventListener(utils.nameMap.dragStart, function () {
                    window.event ? window.event.cancelBubble = true : e.stopPropagation();
                });
                this.template.player_btn.addEventListener(utils.nameMap.dragStart, function () {
                    window.event ? window.event.cancelBubble = true : e.stopPropagation();
                    _this3.player.toggle();
                });
            }
        },
        {
            key: 'initVideoWrapEvents',
            value: function initVideoWrapEvents() {
                var _this4 = this;
                var startX, startY;
                var handleMobileClick = function handleMobileClick(e) {
                    if (_this4.isLocked) {
                        _this4.player.notice('当前播放器已锁定');
                        return;
                    }
                    var nowTime = new Date().getTime();
                    if (nowTime - _this4.lastClickTime < 300) {
                        _this4.clickFlag++;
                        _this4.lastClickTime = 0;
                        _this4.clickTimer && clearTimeout(_this4.clickTimer);
                        _this4.setAutoHide();
                        if (!_this4.isControl) {
                            _this4.player.toggle();
                        }
                    } else {
                        _this4.clickTimer && clearTimeout(_this4.clickTimer);
                        _this4.speedTimer && clearTimeout(_this4.speedTimer);
                        _this4.lastClickTime = nowTime;
                        _this4.singleClick = true;
                        _this4.clickTimer = setTimeout(function () {
                            console.log('单击', _this4.isControl);
                            _this4.toggle();
                            if (_this4.clickFlag > 1) {
                                _this4.clickFlag = 1;
                                return;
                            }
                        }, 300);
                        _this4.speedTimer = setTimeout(function () {
                            console.log('长按', _this4.isControl);
                            if (!_this4.player.video.paused) {
                                _this4.player.template.speedTip.classList.remove('hidden');
                                _this4.player.speed(3);
                                _this4.player.danmaku.speed(1.5);
                            }
                        }, 600);
                    }
                };
                var move = function move(e) {
                    e.stopPropagation();
                    if (e.target.classList.contains('forbidden'))
                        return;
                    if (!_this4.player.video.duration || !_this4.player.template.speedTip.classList.contains('hidden'))
                        return;
                    _this4.isControl = true;
                    _this4.speedTimer && clearTimeout(_this4.speedTimer);
                    _this4.singleClick = false;
                    var offsetX = (e.clientX || e.changedTouches[0].clientX) - startX;
                    var offsetY = startY - (e.clientY || e.changedTouches[0].clientY);
                    var absOffsetX = Math.abs(offsetX);
                    var absOffsetY = Math.abs(offsetY);
                    clearTimeout(_this4.autoHideTimer);
                    if (!_this4.controlMode) {
                        if (absOffsetX > absOffsetY) {
                            _this4.controlMode = 'seek';
                        } else if (absOffsetX < absOffsetY && startX <= 1 / 3 * _this4.player.template.gestureWrap.offsetWidth) {
                            _this4.controlMode = _this4.player.options.mode === 'app' ? 'brightness' : 'volume';
                        } else if (absOffsetX < absOffsetY && startX >= 2 / 3 * _this4.player.template.gestureWrap.offsetWidth) {
                            _this4.controlMode = 'volume';
                        }
                    }
                    if (_this4.controlMode === 'seek') {
                        var offsetValue = offsetX / _this4.player.template.gestureWrap.clientWidth * 90;
                        _this4.setAutoHide();
                        _this4.player.unableTimeupdate = true;
                        _this4.moveTime = Math.max(_this4.player.video.currentTime + offsetValue, 0);
                        _this4.player.bar.set('played', _this4.moveTime / _this4.video.duration, 'width');
                        _this4.seekTip = utils.secondToTime(_this4.moveTime) + ' / ' + utils.secondToTime(_this4.player.video.duration);
                        _this4.showTip();
                    }
                    if (_this4.controlMode === 'volume') {
                        var _offsetValue = offsetY / _this4.player.template.gestureWrap.clientHeight * 2.5;
                        console.log(_this4.volume);
                        _this4.moveVolume = Math.min(Math.max(_this4.volume + _offsetValue, 0), 1);
                        _this4.player.volume(_this4.moveVolume);
                        _this4.player.tip('volume', _this4.moveVolume);
                    }
                    if (_this4.controlMode === 'brightness') {
                        var _offsetValue2 = offsetY / _this4.player.template.gestureWrap.clientHeight * 2.5;
                        _this4.player.events.trigger('brightness_change', _offsetValue2);
                    }
                    window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
                };
                var up = function up(e) {
                    var _this4$player$templat;
                    e.stopPropagation();
                    if (_this4.controlMode === 'seek') {
                        _this4.player.seek(_this4.moveTime);
                        _this4.player.template.currentTime.innerHTML = utils.secondToTime(_this4.moveTime);
                        _this4.player.unableTimeupdate = false;
                        _this4.clickTimer && clearTimeout(_this4.clickTimer);
                    } else if (_this4.controlMode === 'volume') {
                        _this4.volume = _this4.player.video.volume;
                    }
                    if (_this4.speedTimer && !_this4.player.video.paused) {
                        clearTimeout(_this4.speedTimer);
                        if (!_this4.player.template.speedTip.classList.contains('hidden')) {
                            _this4.player.template.speedTip.classList.add('hidden');
                            _this4.player.speed(1);
                            _this4.player.danmaku.speed(1);
                        }
                    }
                    _this4.controlMode && ((_this4$player$templat = _this4.player.template[_this4.controlMode + 'Tip']) === null || _this4$player$templat === void 0 ? void 0 : _this4$player$templat.classList.add('hidden'));
                    _this4.controlMode && _this4.player.events.trigger('tip_hide', _this4.controlMode);
                    _this4.controlMode = null;
                    _this4.isControl = false;
                    _this4.hideTip();
                    document.removeEventListener(utils.nameMap.dragMove, move);
                    document.removeEventListener(utils.nameMap.dragEnd, up);
                };
                this.player.template.gesture.addEventListener(utils.nameMap.dragStart, function (e) {
                    e.stopPropagation();
                    if (_this4.isLocked) {
                        _this4.player.notice('当前播放器已锁定');
                        clearTimeout(_this4.lockTimer);
                        _this4.template.leftLock.classList.remove('hide');
                        _this4.template.rightLock.classList.remove('hide');
                        _this4.lockTimer = setTimeout(function () {
                            _this4.template.leftLock.classList.add('hide');
                            _this4.template.rightLock.classList.add('hide');
                        }, 3000);
                        return;
                    }
                    handleMobileClick(e);
                    startX = e.clientX || e.changedTouches[0].clientX;
                    startY = e.clientY || e.changedTouches[0].clientY;
                    document.addEventListener(utils.nameMap.dragMove, move);
                    document.addEventListener(utils.nameMap.dragEnd, up);
                });
            }
        },
        {
            key: 'initThumbnails',
            value: function initThumbnails() {
                var _this5 = this;
                this.thumbnails = new Thumbnails({
                    container: this.player.template.barPreview,
                    barWidth: this.player.template.bar.offsetWidth,
                    bar: this.player.template.bar,
                    url: this.player.options.video[this.player.currentVideo].thumbnails,
                    events: this.player.events
                });
                this.player.on('loadedmetadata', function () {
                    _this5.thumbnails.resize(160, _this5.player.video.videoHeight / _this5.player.video.videoWidth * 160, _this5.player.template.bar.offsetWidth);
                });
            }
        },
        {
            key: 'initPlayedBar',
            value: function initPlayedBar() {
                var _this6 = this;
                var thumbMove = function thumbMove(e) {
                    window.event ? window.event.cancelBubble = true : e.stopPropagation();
                    _this6.isControl = true;
                    _this6.isBarMove = true;
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - utils.getBoundingClientRectViewLeft(_this6.player.template.bar)) / _this6.player.template.bar.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this6.player.bar.set('played', percentage, 'width');
                    _this6.moveTime = _this6.player.video.duration * percentage;
                    _this6.seekTip = utils.secondToTime(_this6.moveTime) + ' / ' + utils.secondToTime(_this6.player.video.duration);
                    _this6.showTip(e);
                };
                var thumbUp = function thumbUp(e) {
                    window.event ? window.event.cancelBubble = true : e.stopPropagation();
                    clearTimeout(_this6.autoHideTimer);
                    _this6.isControl = false;
                    _this6.setAutoHide();
                    document.removeEventListener(utils.nameMap.dragEnd, thumbUp);
                    document.removeEventListener(utils.nameMap.dragMove, thumbMove);
                    var percentage = ((e.clientX || e.changedTouches[0].clientX) - utils.getBoundingClientRectViewLeft(_this6.player.template.bar)) / _this6.player.template.bar.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this6.player.template.currentTime.innerHTML = utils.secondToTime(percentage * _this6.player.video.duration);
                    _this6.player.bar.set('played', percentage, 'width');
                    _this6.player.seek(_this6.player.bar.get('played') * _this6.player.video.duration);
                    _this6.hideTip();
                    _this6.player.unableTimeupdate = false;
                    _this6.isBarMove = false;
                };
                this.player.template.barWrap.addEventListener(utils.nameMap.dragStart, function (e) {
                    window.event ? window.event.cancelBubble = true : e.stopPropagation();
                    document.addEventListener(utils.nameMap.dragMove, thumbMove);
                    document.addEventListener(utils.nameMap.dragEnd, thumbUp);
                    _this6.player.unableTimeupdate = true;
                    _this6.isBarMove = true;
                });
            }
        },
        {
            key: 'initFullButton',
            value: function initFullButton() {
                var _this7 = this;
                this.player.template.browserFullButton.addEventListener('click', function () {
                    if (_this7.player.options.mode === 'app') {
                        _this7.player.events.trigger('fullscreen');
                    } else {
                        _this7.player.fullScreen.request();
                    }
                });
                this.player.template.headBacker.addEventListener('click', function () {
                    if (_this7.player.fullScreen.isFullScreen()) {
                        _this7.player.fullScreen.cancel();
                    } else {
                        var videoMask = _this7.player.template.videoMask;
                        if (videoMask.classList.contains('fullscreen')) {
                            _this7.player.events.trigger('fullscreen_cancel');
                        } else {
                            _this7.player.events.trigger('back');
                        }
                    }
                });
            }
        },
        {
            key: 'initDanmakuButton',
            value: function initDanmakuButton() {
                var _this8 = this;
                this.player.template.danmakuButton.addEventListener('click', function () {
                    _this8.showDanmaku = !_this8.showDanmaku;
                    _this8.player.danmaku.showing = _this8.showDanmaku;
                    if (_this8.showDanmaku) {
                        _this8.player.danmaku.show();
                        _this8.player.events && _this8.player.events.trigger('danmaku_show');
                    } else {
                        _this8.player.danmaku.hide();
                        _this8.player.events && _this8.player.events.trigger('danmaku_hide');
                    }
                });
            }
        },
        {
            key: 'setAutoHide',
            value: function setAutoHide() {
                var _this9 = this;
                var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
                this.show();
                clearTimeout(this.autoHideTimer);
                this.autoHideTimer = setTimeout(function () {
                    if (!_this9.isControl) {
                        _this9.hide();
                    }
                }, delay);
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.container.classList.remove('mfunsPlayer-hide-controller');
                this.template.rightLock.classList.remove('hide');
                this.hideControlflag = true;
                this.template.gestureWrap.classList.remove('full');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.container.classList.add('mfunsPlayer-hide-controller');
                this.template.gestureWrap.classList.add('full');
                if (!this.isLocked) {
                    this.template.rightLock.classList.add('hide');
                }
                this.hideControlflag = false;
            }
        },
        {
            key: 'isShow',
            value: function isShow() {
                return !this.player.container.classList.contains('mfunsPlayer-hide-controller');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.isShow()) {
                    this.hide();
                } else {
                    this.setAutoHide();
                }
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                clearTimeout(this.autoHideTimer);
            }
        }
    ]);
    return Controller;
}();
export default Controller;